import { FormControl } from "@angular/forms";

/**
 * Product Status Filter Options
 */
export type ProductStatusFilter = "all" | "active" | "inactive" | "invalid";

/**
 * Product Filter Form Controls Interface
 * Matching old QMC filter structure (without Stock Level and Product Types)
 */
export interface IProductFilterControls {
  search: FormControl<string | null>;
  status: FormControl<ProductStatusFilter>;
  productGroupId: FormControl<number | null>;
}

/**
 * Product Filter Values Interface
 * Plain object representation of filter values for API calls
 */
export interface IProductFilterValues {
  search?: string;
  status?: ProductStatusFilter;
  productGroupId?: number;
  page?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: "asc" | "desc";
}

/**
 * Default filter values
 * pageSize=20 matches old QMC default
 */
export const DEFAULT_PRODUCT_FILTER_VALUES: IProductFilterValues = {
  status: "all",
  page: 1,
  pageSize: 20,
  sortField: "ProductName",
  sortOrder: "asc",
};
